import breakpoints from 'scss-settings/_settings.grid.scss';
import DetectBreakpoints from '~utilities/detect-breakpoints';

const JS_STICKY_BREAKPOINT = 'js-sticky-breakpoint';
const JS_STICKY = 'js-sticky';
const STICKY_CLASS = 'is--sticky';
const UNSTICKY_CLASS = 'is--unsticky';

class Sticky {
    constructor(element) {
	    this.element = element;
	    
		this.defineVariables();
	    
	    this.checkBreakpoint();
    }

	defineVariables() {
		this.offset = this.element.getAttribute(JS_STICKY)
	    this.top = this.getTop(this.element);
	    this.bottom = this.element.offsetHeight;
	    const width = this.element.offsetWidth;
	    this.element.style.width = `${width}px`;
	}

    getTop(element) {
        return element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.offset;
    }
    
    checkBreakpoint() {
	    
		let scrollListener = () => this.throttle();
	    
		this.bindEvents(scrollListener);

		window.addEventListener('resize', (event) => {
			this.element.classList.remove(STICKY_CLASS);
	    	this.element.classList.remove(UNSTICKY_CLASS);
			this.element.style.width = ``;
			this.defineVariables();
			window.removeEventListener('scroll', scrollListener);
			this.bindEvents(scrollListener);
		}, true);
    }

	bindEvents(scrollListener) {
		const envs = Object.keys(breakpoints);
        const minBreakpoint = envs.indexOf(this.element.getAttribute(JS_STICKY_BREAKPOINT));
	    const breakpoint = envs.indexOf(DetectBreakpoints.breakpoint);
	    if(minBreakpoint <= breakpoint) {
			this.toggleSticky();
			window.addEventListener('scroll', scrollListener);
	    }
	}
    
    throttle() {
	    if(this.scrollInterval){
		    window.clearTimeout(this.scrollInterval);
		};
	    this.scrollInterval = setTimeout(() => {
		    this.toggleSticky();
	    },10);
    }
    
    toggleSticky() {
		this.bottom = this.element.offsetHeight;
		const parent = this.element.parentElement;
	    const parentBottom = parent.offsetHeight;
	    const parentTop = this.getTop(parent);

		if(parentBottom < this.bottom) {
			this.element.classList.remove(STICKY_CLASS);
			this.element.classList.remove(UNSTICKY_CLASS);
			return;
		}
		
	    const bodyY = document.documentElement && document.documentElement.scrollTop;	    
	    const bottom = this.bottom + bodyY;

		
		if(bodyY < this.top && !this.element.classList.contains(STICKY_CLASS)) this.top = this.getTop(this.element);

	    const toggleTop = bodyY >= this.top ? 'add' : 'remove';
	    this.element.classList[toggleTop](STICKY_CLASS);

	    const toggleBottom = parentBottom + parentTop <= bottom ? 'add' : 'remove';
	    this.element.classList[toggleBottom](UNSTICKY_CLASS);
    }
}

export default Sticky;